import type { SVGProps } from 'react';

const Eye = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8333 8.00001C12.8333 8.66668 11.6667 12.1667 8.00001 12.1667C4.33334 12.1667 3.16667 8.66668 3.16667 8.00001C3.16667 7.33334 4.33334 3.83334 8.00001 3.83334C11.6667 3.83334 12.8333 7.33334 12.8333 8.00001Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 9.5C8.82843 9.5 9.5 8.82843 9.5 8C9.5 7.17157 8.82843 6.5 8 6.5C7.17157 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17157 9.5 8 9.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Eye;
